import type { PlateLeafProps } from 'platejs/react';
import { PlateLeaf } from 'platejs/react';

import styles from './CodeElement.module.scss';

export function CodeElement(props: PlateLeafProps) {
	return (
		<PlateLeaf {...props} as="code" className={styles.code}>
			{props.children}
		</PlateLeaf>
	);
}
